import { render, staticRenderFns } from "./Tutoriales.vue?vue&type=template&id=1b3416cc"
import script from "./Tutoriales.vue?vue&type=script&lang=js"
export * from "./Tutoriales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports